var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", md: "2" } },
            [
              _c("v-chip", { staticClass: "ma-2", attrs: { label: "" } }, [
                _vm._v("Totali Valutazione Offerta"),
              ]),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4", md: "2" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Importo Offerta",
                  prefix: "€",
                  type: "number",
                  readonly: "",
                  "hide-details": "",
                },
                model: {
                  value: _vm.ImportoOffertaTotaleValutazione,
                  callback: function ($$v) {
                    _vm.ImportoOffertaTotaleValutazione = $$v
                  },
                  expression: "ImportoOffertaTotaleValutazione",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4", md: "2" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Costo Atteso",
                  prefix: "€",
                  type: "number",
                  readonly: "",
                  "hide-details": "",
                },
                model: {
                  value: _vm.CostoAttesoTotaleValutazione,
                  callback: function ($$v) {
                    _vm.CostoAttesoTotaleValutazione = $$v
                  },
                  expression: "CostoAttesoTotaleValutazione",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4", md: "2" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Margine Atteso",
                  prefix: "€",
                  type: "number",
                  readonly: "",
                  "hide-details": "",
                },
                model: {
                  value: _vm.MargineAttesoTotaleValutazione,
                  callback: function ($$v) {
                    _vm.MargineAttesoTotaleValutazione = $$v
                  },
                  expression: "MargineAttesoTotaleValutazione",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4", md: "2" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Margine Atteso %",
                  prefix: "%",
                  type: "number",
                  readonly: "",
                  "hide-details": "",
                },
                model: {
                  value: _vm.MargineAttesoPercTotaleValutazione,
                  callback: function ($$v) {
                    _vm.MargineAttesoPercTotaleValutazione = $$v
                  },
                  expression: "MargineAttesoPercTotaleValutazione",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }